import { parseGmailQuery, type GmailQueryPart } from '@littlebird/ui-utils';
import { Fragment } from 'react';

const QueryParts = ({ parts }: { parts: GmailQueryPart[] }) => (
  <>
    {parts.map((part, index) => (
      <Fragment key={index}>
        {index > 0 ? ' ' : null}
        {part.type === 'text' ? (
          <span className="text-foreground-muted">{part.value}</span>
        ) : part.type === 'group' ? (
          <span className="min-w-0 max-w-full leading-7">
            {part.label ? (
              <span className="text-foreground-muted">{part.label} </span>
            ) : null}
            <span className="text-foreground-muted">( </span>
            <QueryParts parts={part.parts} />
            <span className="text-foreground-muted"> )</span>
          </span>
        ) : (
          <span className="inline-block max-w-full align-baseline leading-7">
            {part.label ? (
              <span className="text-foreground-muted">{part.label} </span>
            ) : null}
            <span className="inline-block max-w-full rounded-xl border border-grayA-5 bg-grayA-3 px-2.5 py-0.5 align-baseline font-medium leading-5 text-foreground [overflow-wrap:anywhere]">
              {part.value}
            </span>
          </span>
        )}
      </Fragment>
    ))}
  </>
);

export const RoutineGmailQuery = ({ query }: { query: string }) =>
  query.trim() ? (
    <span role="group" aria-label="Email filter" className="contents">
      <span className="text-foreground-muted">matching </span>
      <QueryParts parts={parseGmailQuery(query)} />
    </span>
  ) : (
    <span className="text-foreground-muted">Matches all emails</span>
  );
